var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 40,
    viewBox: "0 0 180 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1664_12442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1641 25.7659L11.0092 30.1963V40.0005H0V0.771484H11.0092V17.0786L26.2355 0.771484H38.4762L22.4165 18.1459L39.3221 40.0005H26.4096L15.1641 25.7659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2826 19.9326H38.8745V28.111H55.2826V19.9326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9131 0.771484H73.0342V31.2016H91.7934V40.0005H61.9131V0.771484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.98 32.3806H106.348L103.25 40.0005H91.9053L109.271 0.771484H120.231L137.646 40.0005H126.077L122.992 32.3806H122.98ZM119.721 24.2022L114.67 11.6429L109.62 24.2022H119.733H119.721Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.284 23.2088C177.553 24.8718 178.187 26.8823 178.187 29.2278C178.187 32.6655 176.806 35.3213 174.032 37.1828C171.258 39.0568 167.253 39.9876 162.015 39.9876H140.781V0.758545H160.896C165.909 0.758545 169.728 1.67691 172.353 3.53845C174.978 5.38759 176.284 7.88206 176.284 11.0219C176.284 12.8958 175.824 14.5588 174.903 16.0356C173.983 17.5125 172.689 18.679 170.997 19.5354C173.249 20.3172 175.003 21.5458 176.284 23.2088ZM151.79 8.77561V16.3459H159.428C163.172 16.3459 165.051 15.08 165.051 12.5359C165.051 9.99182 163.172 8.77561 159.428 8.77561H151.79ZM166.954 27.9992C166.954 25.3434 165.001 24.0155 161.107 24.0155H151.778V31.9705H161.107C165.001 31.9705 166.954 30.6426 166.954 27.9868",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1664_12442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.78b5ae58.svg";
export { ForwardRef as ReactComponent };